<template>
  <div style="width: 100%">
    <div v-if="!hasH5" class="mains">
      <div class="tip-alert-content">
        <div class="tip-alert" v-show="title!==''">
          <template>
            <el-alert
                center
                :title="title"
                type=""
                @close="closeTip">
            </el-alert>
          </template>
        </div>
      </div>
      <div class="header">
        <div class="header-left" style="cursor: pointer">
          <img @click="toPath('/index')" data-track-text="首页Logo" aria-label="首页Logo" src="../assets/img/logo-big.png" height="50">
        </div>
        <div class="header-right" style="cursor: pointer">
          <div style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-right: 10px">
            <span v-if="groupUserInfo==='机构登录'" data-track-text="机构登录" aria-label="机构登录" @click="showIframe('/login')">{{ groupUserInfo }}</span>
            <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                         style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #ffffff00">
              <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'" class="title_hide">{{ groupUserInfo }}</span>
              <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
                <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                                  style="z-index: 1;font-weight: 800">
                <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                    item.name
                  }}</span>
                  <span
                      style="margin-left:10px; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                      v-if="!item.isIpScore">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
            <el-dropdown @command="logOut" v-if="showloginOut"
                         style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
            <span v-show="userInfo!==''" class="title_hide">
              {{ userInfo }}
            </span>
              <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item style="z-index: 1;font-weight: 800">
                  <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span data-track-text="个人中心" aria-label="个人中心" @click="toCenter">
            <img v-if="userType==='0'" class="user-img" src="../assets/img/person_no.png" alt="">
            <img v-if="userType==='1'" class="user-img" src="../assets/img/child_no.png" alt="">
            <img v-if="userType==='2'" class="user-img" src="../assets/img/roaming_no.png" alt="">
          </span>
          </div>
          <div v-show="userInfo===''" data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</div>
          <div v-show="userInfo===''" data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</div>
          <div>｜</div>
          <div v-if="isShowInRoaming&&showRoaming">
            <el-popover
                @hide="removeQrcode"
                @show="getQrcode"
                placement="top-start"
                title="扫一扫开通漫游"
                width="150"
                trigger="hover">
              <el-image
                  :src="qrcodeUrl"
                  fit="contain"
                  style="width: 150px; height: 150px"
                  alt="开通漫游">
              </el-image>
              <el-button type="text" slot="reference">开通漫游</el-button>
            </el-popover>
            <div style="margin-top: -28px;margin-left: -25px;"><img src="../assets/new_icon.png" alt=""></div>
          </div>
          <div data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">
            帮助
          </div>
        </div>
      </div>
      <!--    <div class="line-hr">
            <hr>
          </div>-->
      <div class="nav">
        <div class="nav-border">
          <div>
            <label>
              <div data-track-text="首页" aria-label="首页" @click="toPath('/')">首页</div>
            </label>
            <label>
              <el-dropdown @command="gotoPage">
                <span>产品</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="text" style="z-index: 1; font-weight: 800">
                    <span>文本翻译</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="doc" style="z-index: 1; font-weight: 800">
                    <span>文档翻译</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="ai" style="z-index: 1; font-weight: 800">
                    <span>AI翻译</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="lange" style="z-index: 1; font-weight: 800">
                    <span>多语种翻译</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="polish" style="z-index: 1; font-weight: 800">
                    <span>润色改写</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="aiPPT" style="z-index: 1; font-weight: 800">
                    <span>AI PPT</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="rag" style="z-index: 1; font-weight: 800; position: relative;">
                    <span>RAG知识库</span>
                    <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </label>
            <label v-show="isShowTransPro">
              <div data-track-text="人工翻译" aria-label="人工翻译" @click="toPath('/trans-pro')">人工翻译</div>
            </label>
            <label>
              <div data-track-text="PDF转换" aria-label="PDF转换" @click="toPath('/convert')" class="index">PDF转换</div>
            </label>
            <label>
              <div data-track-text="历史文档" aria-label="历史文档" @click="toPath(isShowTransPro?'/list-pro':'/list')">历史文档</div>
            </label>
          </div>
        </div>
      </div>
      <div class="upload-main-top-content">
        <div class="upload-main-top"></div>
      </div>
      <div class="uploads-main-big">
        <div class="uploads-main" v-show="showDoc">
          <el-form
              ref="uploadForm"
              :rules="uploadrules"
              :model="uploadform"
              :inline="true"
              class="demo-form-inline"
          >
            <div @click="getUserStatus" data-track-text="上传PDF转换文件" aria-label="上传PDF转换文件">
              <el-upload
                  class="new-upload-demo"
                  :disabled="isUploadDisabled"
                  action
                  drag
                  multiple
                  ref="fileUpload"
                  :class="elUploadMdjy"
                  accept=".pdf"
                  :limit="count"
                  :on-exceed="onExceed"
                  :file-list="fileList"
                  :auto-upload="autoUpload"
                  :before-upload="beforeUpload"
                  :http-request="submitUploadFiles"
                  :on-error="onError"
                  :on-success="onSuccess"
                  :on-remove="handleRemove"
              >
                <div :class="elUploadMdjy">
                  <div class="content">
                    <div class="el-upload-titjy">
                      拖入/选择 要转换的文档
                      <span style="color: #999999">（可批量上传）</span>
                    </div>
                    <div class="scbncg">
                      <span style="color: #999999;font-size: 14px;">上传文档不能超过20M</span>
                    </div>
                    <div class="uptitle">
                      确认转换
                    </div>
	                    <div
	                        style="margin-top:20px;cursor:pointer;font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;"
	                        data-track-text="转换页切换发送邮箱"
	                        aria-label="转换页切换发送邮箱"
	                        @click.stop="()=>{return 0}">
                      <el-checkbox style="display: flex;" class="hasSendMailClass" @change="setHasSendMail"
                                   v-model="hasSendMail">
                          <span
                              style="font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
                            是否需要发送译文至邮箱<span v-show="hasSendMail&&email!==''">（发送至{{ email }}）</span>
                          </span>
                      </el-checkbox>
                    </div>
                    <div class="uptip">
                  <span> 限时优惠，转换
                    <span style="color:#E13C3C;">0.1</span>元/页（原价<span
                        style="color:#E13C3C;">0.3</span>元/页）
                  </span>
                    </div>
                  </div>
                </div>
              </el-upload>
            </div>
          </el-form>
        </div>
      </div>
      <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" class="payClass1">
        <el-table :data="gridData"
                  :header-cell-style="{ 'background': '#d3dee8','line-height': '30px','height': '23px',
                'text-align':'center','font-size':'14px','color':'#333333'}"
        >
          <el-table-column type="index" property="id" label="序号" width="50" align="center"></el-table-column>
          <el-table-column property="title" label="题名" show-overflow-tooltip></el-table-column>
          <el-table-column property="page" label="校验页数" width="100" align="center"></el-table-column>
          <el-table-column property="money" label="金额（元）" width="100" align="center"
                           v-if="isShowMoney"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <div style="float: left;
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
    width: 80%;">
            <div style="float: left">
              总计：<span>{{ pages }}</span>页
            </div>
            <div style="float: right" v-if="isShowMoney">
              <span style="padding-right: 15px;">总价：￥{{ NumFilter(orderMoney) }}</span>
              <span style="padding-right: 15px;">优惠：
              <span style="color:#e13f3f;">{{ NumberSub(orderMoney, moneys) }}</span>
            </span>
              <span style="padding-right: 15px;">实付：<span
                  style="color:#e13f3f ;font-size: 18px;">￥{{ NumFilter(moneys) }}</span></span>
            </div>
          </div>
          <el-button v-if="!isShowFree" type="primary" data-track-text="确认转换" aria-label="确认转换" @click="submitPay" class="okTranslate">确认转换</el-button>
          <el-button v-if="isShowFree" type="primary" data-track-text="免费转换" aria-label="免费转换" @click="submitPay" class="okTranslate">免费转换</el-button>
        </div>
      </el-dialog>
      <div class="foot">
        <span>© 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All rights reserved. 京公网安备</span>
        <span><a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
        <span style="margin-left: 15px">联系电话：010-80755328</span></span>
      </div>
      <floating-contact-tools show-qq />
      <el-dialog
          :top="'40vh'"
          :show-close="false"
          :visible.sync="setMailVisible"
          width="280px"
          center>
        <span slot="title"
              style="font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
           您暂未设置邮箱，请填写邮箱
        </span>
        <div style="width: 100%;display: flex;justify-content: center">
          <div
              style="width: 95px;height: 30px;background: #063F95;border-radius: 5px;display: flex;align-items: center;justify-content: center;">
            <span style="cursor: pointer;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;"
                  data-track-text="填写邮箱"
                  aria-label="填写邮箱"
                  @click="toSetMail">
              填写邮箱
            </span>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="hasH5" class="main-index">
      <div class="header">
        <div class="login" v-show="userInfo===''" data-track-text="H5转换登录" aria-label="H5转换登录" @click="toPath('/h5/login')">
          登录
        </div>
        <div class="login" v-show="userInfo!==''">
          <el-dropdown @command="logOut" v-if="showloginOut"
                       style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
            <span v-show="userInfo!==''" class="title_hide"
                  style="overflow-x: hidden;text-overflow: ellipsis;width: 100px;white-space: nowrap;">
              {{ userInfo }}
            </span>
            <el-dropdown-menu v-if="showloginOut" slot="dropdown">
              <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">充值中心</span>
              </el-dropdown-item>
              <el-dropdown-item command="toAccount" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人设置</span>
              </el-dropdown-item>
              <el-dropdown-item command="toOrder" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">订单详情</span>
              </el-dropdown-item>
              <el-dropdown-item style="z-index: 1;font-weight: 800">
                <span style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span data-track-text="H5转换个人中心" aria-label="H5转换个人中心" @click="toCenter">
            <img v-if="userType==='0'" class="user-img" src="../assets/img/person_no.png" alt="">
            <img v-if="userType==='1'" class="user-img" src="../assets/img/child_no.png" alt="">
            <img v-if="userType==='2'" class="user-img" src="../assets/img/roaming_no.png" alt="">
          </span>
        </div>
        <div v-if="groupUserInfo==='机构登录'" class="login" data-track-text="H5转换机构登录" aria-label="H5转换机构登录" @click="toPath('/h5/login')">
          <span>机构登录</span>
        </div>
        <div v-if="groupUserInfo!=='机构登录'"
             style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="login">
          <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                       style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
          <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="title_hide">{{
              groupUserInfo
            }}</span>
            <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
              <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                                style="z-index: 1;font-weight: 800">
                <span style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                    item.name
                  }}</span>
                <span
                    style="margin-left:10px; font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                    v-if="!item.isIpScore">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="select" style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
          PDF转换
        </div>
        <div class="select">
          <div @click="showSelect=!showSelect" class="select-option" data-track-text="展开导航菜单" aria-label="展开导航菜单">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-show="showSelect" class="selected">
          <div data-track-text="H5转换导航首页" aria-label="H5转换导航首页" @click="toPath('/index')">首页</div>
          <div data-track-text="H5转换导航立即翻译" aria-label="H5转换导航立即翻译" @click="toPath('/translate')">立即翻译</div>
          <div data-track-text="H5转换导航人工翻译" aria-label="H5转换导航人工翻译" @click="toPath('/trans-pro')" v-if="isShowTransPro">人工翻译</div>
          <div data-track-text="H5转换导航PDF转换" aria-label="H5转换导航PDF转换" @click="toPath('/convert')">PDF转换</div>
          <div data-track-text="H5转换导航历史文档" aria-label="H5转换导航历史文档" @click="toPath('/list')">历史文档</div>
        </div>
      </div>
      <div class="convert-main">
        <div class="convert-main-head">
          <img src="../assets/H5/convert-bac.png" alt="">
        </div>
        <div class="convert-main-content">
          <div class="convert-main-content-upload-border">
            <div class="uploads-main">
              <div v-show="!showUploadOk" class="trans-main-content-ok">
                <div class="trans-main-content-ok-font">
                  <div>上传成功</div>
                  <div><img src="../assets/H5/upload-success.png" alt="" width="44"/></div>
                </div>
                <div class="trans-main-content-ok-button" data-track-text="提交PDF转换支付" aria-label="提交PDF转换支付" @click="submitPay">
                  {{ isShowFree ? '立即查看' : '立即支付' }}
                </div>
              </div>
              <el-form v-show="showUploadOk"
                       ref="uploadForm"
                       :rules="uploadrules"
                       :model="uploadform"
                       :inline="true"
                       class="demo-form-inline"
              >
                <div @click="getUserStatus" data-track-text="上传PDF转换文件" aria-label="上传PDF转换文件">
                  <el-upload
                      class="new-upload-demo"
                      :disabled="isUploadDisabled"
                      action
                      drag
                      multiple
                      ref="fileUpload"
                      :class="elUploadMdjy"
                      accept=".pdf"
                      :limit="count"
                      :on-exceed="onExceed"
                      :file-list="fileList"
                      :auto-upload="autoUpload"
                      :before-upload="beforeUpload"
                      :http-request="submitUploadFiles"
                      :on-error="onError"
                      :on-success="onSuccess"
                      :on-remove="handleRemove"
                  >
                    <div :class="elUploadMdjy">
                      <div class="content">
                        <div class="el-upload-titjy">
                          拖入/选择 要转换的文档
                          <span style="color: #999999">（可批量上传）</span>
                        </div>
                        <div class="scbncg">
                          <span style="color: #999999;font-size: 24px;">上传文档不能超过20M</span>
                        </div>
                        <div class="uptitle" style="margin-bottom: 47px">
                          确认转换
                        </div>
	                        <div
	                            style="display: flex;    flex-flow: column;    align-items: center;    justify-content: center;cursor:pointer;font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;"
	                            data-track-text="H5转换页切换发送邮箱"
	                            aria-label="H5转换页切换发送邮箱"
	                            @click.stop="()=>{return 0}">
                          <el-checkbox style="display: flex;" class="hasSendMailClassH5" @change="setHasSendMail"
                                       v-model="hasSendMail">
                          <span
                              style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
                            是否需要发送译文至邮箱
                          </span>
                          </el-checkbox>
                          <div
                              style="margin-top:10px;cursor:pointer;font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
                            <span v-show="hasSendMail&&email!==''">（发送至{{ email }}）</span>
                          </div>
                        </div>
                        <div class="uptip">
                  <span> 限时优惠，转换
                    <span style="color:#E13C3C;">0.1</span>元/页（原价<span
                        style="color:#E13C3C;">0.3</span>元/页）
                  </span>
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="main-foot" style="flex-flow: column">
        <div>
          © 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All
          rights reserved. 京公网安备 11011402010815号
        </div>
        <div style="margin-top: 10px">
          <a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
          <span style="margin-left: 15px">联系电话：010-80755328</span>
        </div>
      </div>
    </div>
      <el-dialog
          :top="'40vh'"
          :show-close="false"
          :visible.sync="setMailVisible"
          width="460px"
          center>
        <span slot="title"
              style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
           您暂未设置邮箱，请填写邮箱
        </span>
        <div style="width: 100%;display: flex;justify-content: center">
          <div
              style="width: 152px;height: 48px;background: #063F95;border-radius: 5px;display: flex;align-items: center;justify-content: center;">
	            <span style="cursor: pointer;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;"
	                  data-track-text="转换页填写邮箱"
	                  aria-label="转换页填写邮箱"
	                  @click="toSetMail">
              填写邮箱
            </span>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  authServiceClient,
  outRequest,
  thirdLoginRequest,
  userPowerRequest,
  userStatusRequest
} from "@/tools/api/auth-api";
import lanuagefrom from "../../languagefrom.json";
import languageto from "../../languageto.json";
import languages from "../../language.json";
import {translateServiceClient} from "@/tools/api/service";
import {
  checkRoamingRequest, getEmailRequest,
  parentPowerRequest,
  submitConvertRequest,
  uploadConvertPDFRequest,
  uploadCountRequest,
  uploadTipRequest
} from "@/tools/api/translate-api";
import {Loading} from "element-ui";
import FloatingContactTools from "@/components/home/FloatingContactTools.vue";

export default {
  name: "NewConvert",
  components: { FloatingContactTools },
  data() {
    return {
      email: '',
      setMailVisible: false,
      hasSendMail: false,
      showUploadOk: true,
      showSelect: false,
      hasH5: false,
      isShowTransPro: false,
      languages2: "languages",
      languages: "languages",
      originalFrom: "自动检测",
      originalTo: "中文(简体)",
      originaltext: "",
      translatetext: "",
      showTxt: false,
      showDoc: true,
      showImg: false,
      isShowMoney: false,
      isShowFree: false,
      orderMoney: 0,
      moneys: 0,
      pages: 0,
      idData: [],
      dialogTableVisible: false,
      gridData: [],
      title: '',
      selectOption: 'selectOption',
      uploadCount: 0,
      limitCount: 20,
      count: 10,
      isUploadDisabled: true,
      isImgUploadDisabled: true,
      isShowupload: true,
      showupload: "",
      elUploadMdjy: "",
      showUpload1: true,
      showUpload2: true,
      timer: "",
      autoUpload: true,
      hasUpload: false,
      lanuagesFrom: lanuagefrom,
      lanuagesTo: languageto,
      uploadform: {
        from: "auto",
        to: "zh",
      },
      uploadrules: {
        from: [{required: true, message: "请输入原文语言", trigger: "blur"}],
        to: [{required: true, message: "请输入目标语言", trigger: "blur"}],
      },
      fileList: [],
      uploaddemo: "new-upload-demo",
      uploadLoading: false,
      one: true,
      two: false,
      three: false,
      four: false,
      one2: true,
      two2: false,
      three2: false,
      lastTime: 0,

      qrcodeUrl: '',
      groupUserInfos: [],
      userInfo: '',
      userType: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      showRoaming: false,
      groupUserInfo: '',
      userId: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowInRoaming: false,
    }
  },
  watch: {
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.fileUpload.clearFiles();
        this.$refs.fileUpload.$data.uploadFiles = [];
        this.idData = [];
        this.gridData = [];
        this.orderMoney = 0;
        this.moneys = 0;
        this.pages = 0;
        this.isUploadDisabled = false;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy";
        }
        this.uploaddemo = "new-upload-demo"
        this.$router.push(
            {
              path: '/list',
              query: {
                type: "convert"
              }
            }
        )
      } else {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    }
  },
  beforeCreate() {
    const that = this;
    window.addEventListener('message', function (e) {
      if (e.data.data === "params") {
        if (that.hasH5) {
          that.$router.push('/h5/login')
          return
        }
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      }
      if (e.data.data === "register") {
        that.openTry()
      }
      if (e.data.data === "close") {
        layer.closeAll()
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true
      }
    })
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false
        this.groupUserInfo = "";
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false
    });
  },
  created() {
    this.getUploadTip();
  },
  mounted() {
    this.hasH5 = this.isMobile()
    if (this.hasH5) {
      this.showupload = "new-el-upload-manjy-h5";
      this.elUploadMdjy = "new-el-upload-mdjy-h5";
    } else {
      this.showupload = "new-el-upload-manjy";
      this.elUploadMdjy = "new-el-upload-mdjy";
    }
    const that = this;
    this.checkUploadCountByDay1();
    this.timer = setInterval(function () {
      let x = document.getElementsByClassName("el-progress__text");
      let count = 0;
      for (let i = 0; i < x.length; i++) {
        if (x[i].innerHTML === "100%") {
          count = count + 1;
          console.log(x[i])
          x[i].parentNode.previousSibling.previousSibling.previousSibling.style.display = "block";
        }
      }
      if (x.length !== 0 && count === x.length) {
        clearInterval(that.timer);
        setTimeout(function () {
          if (that.hasH5) {
            that.showUploadOk = false;
            that.getPower()
            return
          }
          that.dialogTableVisible = true;
        }, 1500);
      }
    }, 10);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    gotoPage(type) {
      const translateTypeMap = {
        text: 'txt',
        doc: 'doc',
        ai: 'AITranslate',
        lange: 'more',
        polish: 'polish',
        aiPPT: 'aiPPT'
      };
      if (type === 'rag') {
        this.toPath('/rag');
        return;
      }
      if (translateTypeMap[type]) {
        this.$router.push({
          path: '/translate',
          query: {
            type: translateTypeMap[type]
          }
        });
      }
    },
    setHasSendMail(val) {
      if (val) {
        let loadingInstance = Loading.service({fullscreen: true, text: '获取邮箱中...', customClass: 'loadClass'});
        const TOKEN_KEY = "token";
        translateServiceClient.getEmail(getEmailRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          let mail = res.getMail();
          if (mail === null || mail === '' || mail === undefined) {
            this.hasSendMail = false
            this.setMailVisible = true
            loadingInstance.close()
            return
          }
          this.email = mail
          this.hasSendMail = val
          loadingInstance.close()
        }).catch(err => {
          if (err.code === 5) {
            this.email = '';
            this.hasSendMail = false
            loadingInstance.close()
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            if (this.hasH5) {
              this.$router.push('/h5/login')
              return false
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            return
          }
          this.email = '';
          this.hasSendMail = false
          this.$message.error("获取邮箱失败，请稍后再试")
          loadingInstance.close()
        })
        return;
      }
      this.email = '';
      this.hasSendMail = val
    },
    toSetMail() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    getPower() {
      let request = parentPowerRequest;
      request.setMoney(this.moneys)
      const TOKEN_KEY = "token";
      translateServiceClient.checkParentPower(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowMoney = res.getShowmoney();
        if (this.isShowMoney && this.moneys === 0) {
          this.isShowFree = true;
        }
      }).catch(err => {
        this.isShowMoney = true;
      })
    },
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowTransPro = res.getIsTransPro();
        this.isShowInRoaming = res.getIsRoaming();
        this.title = res.getMessage();
        if (this.title === undefined || this.title === null || this.title === '') {
          this.selectOption = "selectOption1"
        }
      }).catch(err => {
        this.title = '';
        this.selectOption = "selectOption1"
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
      });
    },
    checkUploadCountByDay1() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.isImgUploadDisabled = true;
              if (this.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.isImgUploadDisabled = false;
            if (this.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            that.uploaddemo = "new-upload-demo"
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            return false;
          })
    },
    submitUploadFiles(event) {
      let time
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            if (this.hasH5) {
              this.uploaddemo = "new-upload-demo-none-h5";
            } else {
              this.uploaddemo = "new-upload-demo-none"
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadConvertPDFRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setSendMail(this.hasSendMail)
              translateServiceClient
                  .uploadConvertPDF(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100})
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                      this.uploaddemo = "new-upload-demo"
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push('/h5/login')
                        return
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push('/h5/login')
            return
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    submitPay() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitConvert(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          this.$router.push(
              {
                path: '/list',
                query: {
                  type: "convert"
                }
              }
          )
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    onSuccess() {
      return false;
    },
    handleRemove(file) {
      this.$refs.fileUpload.abort(); //取消上传
      this.$refs.fileUploadImg.abort();
    },
    onError(err, file, fileList) {
    },
    onExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "篇文献")
        this.isUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        this.uploaddemo = "new-upload-demo"
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;篇</span>"
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.uploaddemo = "new-upload-demo"
      this.isUploadDisabled = false;
    },
    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension = testmsg === "pdf";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 20971520;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      return extension && islimit;
    },
    closeTip() {
      this.selectOption = "selectOption1"
    },
    getUserStatus() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          }).then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push('/h5/login')
            return
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          return false;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          if (this.hasH5) {
            this.$router.push('/h5/login')
            return false
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          return false;
        }
        return that.checkUserPower();
      }).catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        if (this.hasH5) {
          this.$router.push('/h5/login')
          return false
        }
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        return false;
      });

    },
    checkUserPower() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient.checkUserPower(userPowerRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      })
          .then(res => {
            if (!res.getStatus()) {
              that.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push('/h5/login')
                return false
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
              return false;
            }
            return that.checkUploadCountByDay();
          }).catch(err => {
        if (this.hasH5) {
          this.$router.push('/h5/login')
          return false
        }
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        return false;
      })
    },
    checkUploadCountByDay() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              if (this.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            if (this.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push('/h5/login')
                return false
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              that.$message.error("文件上传遇到了问题，请稍后再试！");
            }
            return false;
          })
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    showTip() {
      const tip = sessionStorage.getItem("payTip");
      if (this.$route.path === "/" || this.$route.path === "/index") {
        if (tip === undefined || tip === null || tip === "") {
          this.payCenterDialogVisible = true;
        }
      }
    },
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code)
      request.setState(state)
      const TOKEN_KEY = 'token';
      authServiceClient.thirdLogin(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let status = res.getStatus();
        if (status === "400") {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          setTimeout(this.toNew, 3000);
          return;
        }
        if (status === "201") {
          let openid = res.getOpenid();
          let type = res.getType();
          this.$router.push({
            name: "Bind",
            params: {openid: openid, type: type}
          })
          return;
        }
        if (status === "200") {
          this.$router.push("/index")
          window.location.reload()
          return;
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "登录失败请重试"
        });
      })
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    toPath(url) {
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            if (this.hasH5) {
              this.$router.push('/h5/login')
              return
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push('/h5/login')
                return
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            }).catch(err => {
              if (this.hasH5) {
                this.$router.push('/h5/login')
                return
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            })
          }
        }).catch(err => {
          if (this.hasH5) {
            this.$router.push('/h5/login')
            return
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        });
        return
      }
      this.$router.push(url);
    },
    showIframe(url) {
      return this.$authPopup.open(url, { area: ['948px', '501px'] })
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      }
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", '_blank')
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        if (this.hasH5) {
          this.$router.push('/h5/login')
          return
        }
        this.userInfo = "";
        this.showRoaming = false
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    },
  }
}
</script>
<style lang="less">
.loadClass {
  .el-loading-spinner .path {
    stroke: #063f95;
  }

  .el-loading-spinner .el-loading-text {
    color: #063f95;
  }
}
.hasSendMailClassH5 {
  .el-checkbox__input {
    width: 24px;
    height: 24px;
    background: #fff;
    border: 1px solid #CCCCCC;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #DCDFE6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #FFF;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #063f95;
    width: 11px;
    height: 11px;
    background: #063f95;
  }

  .el-checkbox__inner::after {
    display: none;
  }
}
.hasSendMailClass {
  .el-checkbox__input {
    width: 17px;
    height: 17px;
    background: #fff;
    border: 1px solid #CCCCCC;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #DCDFE6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #FFF;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #063f95;
    width: 11px;
    height: 11px;
    background: #063f95;
  }

  .el-checkbox__inner::after {
    display: none;
  }
}
</style>

<style lang="less" scoped>
/deep/ .new-upload-demo-none-h5 {
  .el-upload {
    display: none;
  }
}

/deep/ .new-el-upload-mdjy-display-h5 {
  .el-upload {
    display: none;
  }

  margin-left: 60px;
  align-items: end !important;
}

.new-el-upload-mdjy-none-h5 {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }

    }
  }


  .convert-main {
    min-width: 765px;
    width: 100%;
    background: #ffffff;
    display: flex;
    flex-flow: column;
    align-items: center;

    .convert-main-head {
      width: 100%;
      height: 333px;
      background: #F5F5F5;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: flex-end;
    }

    .convert-main-content {
      width: 100%;
      height: 798px;
      background: #FFFFFF;
      display: flex;
      flex-flow: column;
      align-items: center;

      .convert-main-content-upload-border {
        width: 705px;
        height: 798px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;

        .uploads-main {
          .trans-main-content-ok {
            height: 689px;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;

            .trans-main-content-ok-font {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
              line-height: 1px;

              div:nth-child(1) {
                margin-right: 14px;
              }
            }

            .trans-main-content-ok-button {
              width: 261px;
              height: 60px;
              background: #063F95;
              border-radius: 35px 0px 35px 0px;
              margin-top: 48px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #F5F5F5;
              line-height: 52px;
              text-align: center;
            }
          }

          /deep/ .new-upload-demo {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin-top: 121px;

            .el-upload-dragger {
              width: 650px;
              height: 415px;
              border: 1px dashed #d9d9d9;

              .new-el-upload-mdjy-h5 {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                line-height: 30px;
                cursor: pointer;

                .content {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;

                  .el-upload-titjy {
                    margin-top: 60px;
                    width: 433px;
                    height: 40px;
                    font-size: 24px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    line-height: 48px;
                  }

                  .scbncg {
                    width: 253px;
                    height: 25px;
                    font-size: 24px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 20px;
                  }

                  .uptitle {
                    margin-top: 40px;
                    width: 261px;
                    height: 60px;
                    border-radius: 35px 0px 35px 0px;
                    align-items: center;
                    justify-content: center;
                    background: #063F95;
                    color: #F5F5F5;
                    font-size: 24px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #F5F5F5;
                    line-height: 52px;
                  }

                  .uptip {
                    margin-top: 28px;
                    width: 382px;
                    height: 21px;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                  }
                }
              }
            }

            .el-upload-list {
              margin-bottom: 30px !important;

              .el-upload-list__item .el-progress {
                position: absolute;
                top: 44px;
                width: 100%;
              }

              .el-upload-list__item .el-progress__text {
                font-size: 24px !important;
                margin-top: -16px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
              }

              .el-upload-list__item {
                text-align: left;
                transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
                font-size: 14px;
                color: #606266;
                line-height: 1.8;
                margin-top: 20px;
                position: relative;
                box-sizing: border-box;
                border-radius: 4px;
                width: 623px;

                .el-icon-document {
                  position: absolute;
                  margin-left: -49px;
                  margin-top: -2.5px;
                  font-size: 45px;
                  color: #bebebe;
                }

                .el-upload-list__item-name {
                  width: 500px;
                  height: 40px;
                  font-size: 24px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                }

                .el-progress-bar__outer {
                  height: 14px !important;
                  width: 623px;
                }


                .el-progress-bar__inner {
                  background-color: #4dbe92 !important;
                  height: 14px;
                }

                .el-icon-upload-success {
                  display: none;
                  color: #67c23a;
                  position: absolute;
                  margin-left: 19px;
                  margin-top: 7.5px;
                  height: 14px;
                  font-size: 26px;
                }
              }
            }
          }

          /deep/ .new-el-upload-manjy-h5 {
            width: 560px;
            margin-bottom: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .el-divider.el-divider--horizontal {
              width: 470px;
              margin: 0;

              .el-divider__text.is-center {
                font-size: 16px;
                font-family: "Microsoft YaHei";
                color: #999999;
              }
            }

          }

          .list {
            margin-top: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;

            div {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              color: #999999;

              span {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 36px;
    }
  }
}

.user-img {
  width: 16px;
  float: right;
  padding-left: 5px;
}

.okTranslate {
  border-color: #184482;
  width: 142px;
  height: 40px;
  background: #184482;
  border-radius: 2px;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}

/deep/ .payClass1 {
  .el-dialog {
    min-width: 800px;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
    line-height: 50px;
  }

}

/deep/ .dialog-title {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;

  .el-form--inline .el-form-item, .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }
}

.mains {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-size: 100% 1080px;
  height: 1080px;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {

      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: #063F95;
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #DDDDDD;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(3):hover {
        background-color: #1565dc;
      }
    }
  }

  .line-hr {
    display: flex;
    width: 100%;
    height: 1px;
    background: #DDDDDD;
    border: 0;
  }

  .nav {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    //background: #ffffff;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

    .nav-border {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #e6e6e6;

      div {
        display: flex;
        width: 1200px;
        justify-content: flex-start;
        align-items: center;

        label {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          width: 10%;
          cursor: pointer;

          .index {
            display: flex;
            width: 64px;
            height: 58px;
            border-bottom: 2px solid #0049B9;
            color: #0049B9;
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          div:nth-child(1):hover {
            width: 38px;
            height: 58px;
            border-bottom: 2px solid #0049B9;
            color: #0049B9;
            justify-content: center;
            align-items: center;
          }
        }

        label:nth-child(1) {
          width: 7%;
        }

        label:nth-child(2) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            border-bottom: 2px solid #0049B9;
            color: #0049B9;
          }
        }

        label:nth-child(3) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            border-bottom: 2px solid #0049B9;
            color: #0049B9;
          }
        }

        label:nth-child(4) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            border-bottom: 2px solid #0049B9;
            color: #0049B9;
          }
        }

        label:nth-child(5) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
          }
        }
      }
    }

  }

  .tip-alert-content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;

    /deep/ .tip-alert {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;

      .el-alert.is-center {
        background: #ffe4cc !important;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffa557;
        height: 37px;
      }
    }
  }

  .upload-main-top-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: RGBA(245, 245, 245, 1);

    .upload-main-top {
      margin-top: 60px;
      width: 1200px;
      height: 255px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("../assets/img/convert-bac1.png") #e6e6e6 no-repeat center;
    }
  }

  .uploads-main-big {
    display: flex;
    width: 100%;
    background-color: #ffffff;
    align-items: center;
    justify-content: center;

    .uploads-main {
      display: flex;
      width: 1198px;
      height: 545px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-right: 1px solid #dddddd;
      border-left: 1px solid #dddddd;
      background: #ffffff;

      /deep/ .new-upload-demo {
        display: flex;
        width: 1200px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 90px;

        .el-upload-dragger {
          height: 333px;
          width: 540px;
          border: 0px dashed #d9d9d9;

          .new-el-upload-mdjy {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 30px;
            cursor: pointer;

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-upload-titjy {
                font-family: "Microsoft YaHei";
                font-weight: 400;
                font-size: 16px;
                color: #333333;
              }

              .scbncg {
                font-family: "Microsoft YaHei";
                font-weight: 400;
              }

              .uptitle {
                margin-top: 40px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                font-size: 18px;
                display: flex;
                width: 260px;
                height: 48px;
                align-items: center;
                justify-content: center;
                background: #063F95;
                border-radius: 26px 0px 26px 0px;
                color: #F5F5F5;
              }

              .uptip {
                margin-top: 28px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
              }
            }
          }
        }

        .el-upload-list {
          margin-bottom: 30px !important;

          .el-upload-list__item {
            text-align: left;
            transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
            font-size: 14px;
            color: #606266;
            line-height: 1.8;
            margin-top: 20px;
            position: relative;
            box-sizing: border-box;
            border-radius: 4px;
            width: 300px;

            .el-icon-document {
              position: absolute;
              margin-left: -49px;
              margin-top: -2.5px;
              font-size: 26px;
              color: #bebebe;
            }

            .el-progress-bar__outer {
              height: 7px !important;
            }

            .el-progress-bar__inner {
              background-color: #4dbe92 !important;
            }

            .el-icon-upload-success {
              color: #67c23a;
              position: absolute;
              margin-left: 19px;
              margin-top: 7.5px;
              font-size: 26px;
            }
          }
        }
      }

      /deep/ .new-el-upload-manjy {
        width: 560px;
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .el-divider.el-divider--horizontal {
          width: 470px;
          margin: 0;

          .el-divider__text.is-center {
            font-size: 16px;
            font-family: "Microsoft YaHei";
            color: #999999;
          }
        }

      }

      .list {
        margin-top: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999999;

          span {
            margin-top: 10px;
          }
        }
      }
    }
  }


  .foot {
    display: flex;
    width: 100%;
    background: #F5F5F5;
    height: 80px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #e6e6e6;
    flex-flow: column;

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 28px;
    }
  }
}

/deep/ .new-upload-demo-none {
  .el-upload {
    display: none;
  }
}

/deep/ .new-el-upload-mdjy-display {
  .el-upload {
    display: none;
  }
}

.new-el-upload-mdjy-none {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  height: 224px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.el-input {
  width: 90%;
}
.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}
.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
